;(function($, window, document){
    window.ProductsListing = Me.view.extend({
        options: {

        },
        initialize: function() {
            _.bindAll(this, 'assignRowToProducts', 'breakpointChanged');

            this.addEvents();

            var products = [];
            var product;
            this.$('.product').each(function(index,value) {
                product = {};
                product.id = $(value).attr('data-sku');
                product.name = $(value).find('.product-name').html() + ' - ' + $(value).find('.product-description').html();

                if ($(value).attr('data-sku').indexOf('C1') != -1) {
                    product.brand = 'Radix';
                } else if ($(value).attr('data-sku').indexOf('C2') != -1) {
                    product.brand = 'Volitare';
                } else if ($(value).attr('data-sku').indexOf('C3') != -1){
                    product.brand = 'Braccas';
                }else{
                    if(locale == 'fr'){
                        product.brand = 'Autre';
                    }else {
                        product.brand = 'Other';
                    }
                }

                product.list_name = window.location.href;
                product.variant = $(value).attr('data-finish');
                product.quantity = $(value).find('.quantity').attr('data-value') ? $(value).find('.quantity').attr('data-value') : 1;
                products.push(product)
            });

            console.log(products);


            if(products.length != 0){
                gtag('event', 'view_item_list', {"items": products});
                if (window.fbq) {
                    var fbids = [];
                    for (var i = 0; i < products.length; i++) {
                        fbids.push(products[i].id);
                    }
                    fbq('track', 'ViewContent', {
                        content_ids: fbids,
                        content_type: "product",
                    });
                }
            }
        },
        addEvents: function() {
            Me.dispatch.subscribe('breakpointChanged', this.breakpointChanged);
        },
        breakpointChanged: function(e, params){
            this.assignRowToProducts();
        },
        assignRowToProducts: function(){
            var leftRowHeight = rightRowHeight = 0;
            this.$('.product').each(function(index,value){
                //reset elements' classes
                $(value).removeClass('left right');

                if(leftRowHeight <= rightRowHeight){

                    $(value).addClass('left');
                    leftRowHeight += $(value).outerHeight(true);
                }else{
                    $(value).addClass('right');
                    rightRowHeight += $(value).outerHeight(true);
                }
            });
        }
    });
}(jQuery, window, document));
